/**
 * Created By Hensi Murcia
 */
"use strict";
import { getAuth } from "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { setDisplay, showToast } from "./common";
import phPersonImg from "url:../images/person_placeholder.svg";

let user;
let isRecentLogin = false;
let isEmail;
let dvToast;
let dbUser;
let recaptchaVerifier;

$("document").ready(function () {
  initLs();
  initAuthLs();
});

/**
 * check if user logged in
 */
function initAuthLs() {
  if (window.location.search.includes("action=success")) {
    isRecentLogin = true;
  }
  firebase.auth().onAuthStateChanged(function (data) {
    if (data) {
      //User is logged in
      user = data;
      initUi();
    } else {
      //User needs to log in
      let modLogin = document.getElementById("modLogin");
      setDisplay(modLogin, "flex");
    }
  });
}

function initUi() {
  let spAcc = document.getElementById("spAcc");
  let ivUser = document.getElementById("ivUser");

  isEmail = user.email != null;
  spAcc.textContent = isEmail ? user.email : user.phoneNumber;
  ivUser.src = phPersonImg;
  $(ivUser).on("error", function () {
    ivUser.src = phPersonImg;
  });

  dbUser = firebase.database().ref(`Users/${user.uid}`);
  dbUser.child("info").once("value", function (data) {
    if (data.exists) {
      let info = data.val();
      ivUser.src = info.profile_Image ? info.profile_Image : phPersonImg;
    }
  });
}

function initLs() {
  dvToast = document.getElementById("toast");
  let btnLogin = document.getElementById("btnLogin");
  $(btnLogin).click(function () {
    window.location.replace("../login.html?action=manage");
  });

  let btnContinue = document.getElementById("btnContinue");
  let modDeleteAcc = document.getElementById("modDeleteAcc");
  let modPwVerify = document.getElementById("modPwVerify");
  let modPhoneVerify = document.getElementById("modPhoneVerify");

  $(btnContinue).click(function () {
    if (isRecentLogin) {
      setDisplay(modDeleteAcc, "flex");
    } else {
      if (isEmail) {
        setDisplay(modPwVerify, "flex");
      } else {
        initCaptcha();
        setDisplay(modPhoneVerify, "flex");
      }
    }
  });

  let btnPwContinue = modPwVerify.querySelector(".btnContinue");
  let btnPwCancel = modPwVerify.querySelector(".btnCancel");
  let inPw = document.getElementById("inPw");
  let modError = document.getElementById("modError");
  let btnOk = document.getElementById("btnOk");

  $(btnPwContinue).click(function () {
    let pw = inPw.value.trim();
    if (pw) {
      inPw.value = "";
      verifyEmail(pw, modDeleteAcc, modError);
      setDisplay(modPwVerify, "none");
    } else {
      $(inPw).shake();
      showToast("Cannot be empty", dvToast, null);
    }
  });

  $(btnPwCancel).click(function () {
    setDisplay(modPwVerify, "none");
  });

  $(btnOk).click(function () {
    setDisplay(modError, "none");
  });

  let btnPhoneContinue = modPhoneVerify.querySelector(".btnContinue");
  let btnPhoneCancel = modPhoneVerify.querySelector(".btnCancel");

  $(btnPhoneContinue).click(function () {
    verifyPhone(modPhoneVerify, modDeleteAcc, modError);
  });

  $(btnPhoneCancel).click(function () {
    setDisplay(modPhoneVerify, "none");
  });

  let btnDeleteAcc = document.getElementById("btnDeleteAcc");
  let btnDelCancel = modDeleteAcc.querySelector(".btnCancel");

  $(btnDeleteAcc).click(function () {
    setDisplay(modDeleteAcc, "none");
    deleteAccount();
  });

  $(btnDelCancel).click(function () {
    setDisplay(modDeleteAcc, "none");
  });

  let btnOkSuccess = document.getElementById("btnOkSuccess");
  $(btnOkSuccess).click(function () {
    window.location.replace("../login.html");
  });
}

function initCaptcha() {
  let dvContainer = modPhoneVerify.querySelector("container");
  let params = {
    type: "image", // 'audio'
    size: "normal", // 'invisible' or 'compact'
    badge: "bottomleft", //' bottomright' or 'inline' applies to invisible.
  };
  let recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
    dvContainer,
    params,
    firebase.app()
  );
  recaptchaVerifier.render();
}

function verifyPhone(modPhoneVerify, modDeleteAcc, modError) {
  user
    .reauthenticateWithPhoneNumber(user.phoneNumber, recaptchaVerifier)
    .then((confirmationResult) => {
      let modVerifyCode = document.getElementById("modVerifyCode");
      let btnCodeVerify = modVerifyCode.querySelector("btnContinue");
      let inCode = document.getElementById("inCode");

      setDisplay(modPhoneVerify, "none");
      setDisplay(modVerifyCode, "flex");

      $(btnCodeVerify).unbind();
      $(btnCodeVerify).click(function () {
        let code = inCode.value.trim();
        if (!code) {
          $(inCode).shake();
          showToast("Cannot be empty", dvToast, null);
          return;
        }
        confirmationResult
          .confirm(code)
          .then(function (userCredential) {
            //successfully verified
            isRecentLogin = true;
            inCode.value = "";
            setDisplay(modVerifyCode, "none");
            setDisplay(modDeleteAcc, "flex");
          })
          .catch((e) => {
            inCode.value = "";
            setDisplay(modVerifyCode, "none");
            setDisplay(modError, "flex");
          });
      });
    })
    .catch((e) => {
      setDisplay(modPhoneVerify, "none");
      setDisplay(modError, "flex");
    });
}

function deleteAccount() {
  let modDeletingAcc = document.getElementById("modDeletingAcc");
  setDisplay(modDeletingAcc, "flex");
  user
    .delete()
    .then(() => {
      let modSuccess = document.getElementById("modSuccess");
      setDisplay(modSuccess, "flex");
      setDisplay(modDeletingAcc, "none");
    })
    .catch((error) => {
      let modError = document.getElementById("modError");
      let pMsg = document.getElementById("pMsg");
      pMsg.textContent = "Could not delete account";
      setDisplay(modError, "flex");
      setDisplay(modDeletingAcc, "none");
    });
}

function verifyEmail(pw, modDeleteAcc, modError) {
  let creds = firebase.auth.EmailAuthProvider.credential(user.email, pw);
  user
    .reauthenticateWithCredential(creds)
    .then(() => {
      isRecentLogin = true;
      setDisplay(modDeleteAcc, "flex");
    })
    .catch((error) => {
      setDisplay(modError, "flex");
    });
}

jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
  intShakes = intShakes || 4;
  intDistance = intDistance || 2;
  intDuration = intDuration || 500;

  this.each(function () {
    $(this).css("position", "relative");
    for (var x = 1; x <= intShakes; x++) {
      $(this)
        .animate({ left: intDistance * -1 }, intDuration / intShakes / 4)
        .animate({ left: intDistance }, intDuration / intShakes / 2)
        .animate({ left: 0 }, intDuration / intShakes / 4);
    }
  });
  return this;
};
